<template>
    <Title_Base :icon="icon" :title="text">
    </Title_Base>
</template>


<script>
import Title_Base from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Base.vue";
import ContractMixin from "@/helpers/Mixins/ContractMixin";
import EntityNames from "@/helpers/Constants/EntityNames.js";

export default {
    name: 'Title_Contract',
    props: {},
    components: {
        Title_Base,
    },
    mixins: [ContractMixin],

    data() {
        return {
            entityName: EntityNames.Contract,
        };
    },

    methods: {},

    computed: {
        typeId() {
            return this.item?.ContractTypeId;
        },

        icon() {
            return this.getContractTypeIcon(this.typeId); //from mixin
        },

        text() {
            if (this.loading || !this.item) {
                return this.$t('servicesystem.common_objects.fallbackterms.loading');
            }
            else {
                return `${this.item.Id} ${this.item.Name}`;
            }
        },

        item() {
            return this.$store.getters["entitycontainerstore/getEntity"](this.entityName);
        },

        loading() {
            return this.$store.getters["entitycontainerstore/getEntityLoading"](this.entityName);
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>